/* eslint-disable jsx-a11y/anchor-has-content */
import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import twIcon from '../images/icon/twitter-icon.png'
import igIcon from '../images/icon/ig-icon.png'
import discordIcon from '../images/icon/discord-icon.png'
import logo from '../images/logo.png'
import { useState } from 'react'
import Account from './Account';
import { Drawer } from 'antd';
import { DISCORD_LINK, TWITTER_LINK, INSTAGRAM_LINK } from '../constants';



const Header = styled.header`
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1001;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 56px;
    padding: 0 92px;
    background-color: #000;
    @media (max-width: 1199.98px) {
        padding: 0 16px;
        height: 53px;
    }
`
const Nav = styled.nav`
    display: flex;
    height: 100%;
    @media (max-width: 1199.98px) {
        display: none;
    }
`
const NavItem = styled.li`
    list-style: none;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 15px;
    letter-spacing: 0.9px;
    font-size: 18px;
    @media (max-width: 767.98px) {
      margin: 0;
      font-size: 16px;
    }
`
const NavItemLink = styled.a`
  padding: 13px 8px 6px;
  display: inline-block;
  height: 100%;
  color: inherit;
  font-family: KozGoPr6N-Heavy;
  &:hover {
    color: #fff;
    border-bottom: solid 7px rgba(159, 11, 49);
  }
`
const IconItem = styled.li`
    margin-left: 6px;
    display: flex;
    align-items: center;
    &:nth-child(6) {
        margin-left: 30px;
    }
    @media (max-width: 767.98px) {
      & + & {
        margin-top: 10px;
      }
    }
`

const Logo = styled.img`
    position: absolute;
    left: 106px;
    top: 0;
    width: 161px;
    z-index: 1001;
    @media (max-width: 1199.98px) {
        width: 91px;
        left: 40px;
    }
`

const Hamburger = styled.div`
   display: none;
    @media (max-width: 1199.98px) {
        display: flex;
        flex-direction: column;    
        align-items: center;
        justify-content: space-between;
        height: 22px;
        & div {
            width: 26px;
            height: 4px;
            background-color: #fff;
        }
    }
`

const DropDownContainer = styled.div`
  position: relative;
  @media (max-width: 1199.98px) {
    display: none;
  }
`;

const DropDownHeader = styled.div`
  text-align: center;
  color: #fff;
  height: 36px;
  line-height: 36px;
  width: 36px;
  border: solid 1px #fff;
  font-family: KozGoPr6N-Bold;
  &:hover {
    cursor: pointer;
  }
`;

const DropDownListContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 1;
`;

const DropDownList = styled.ul`
  width: 36px;
  background: rgba(159, 11, 49);
  padding: 0;
  margin-bottom: 0;
  height: 36px;
  font-family: KozGoPr6N-Bold;
  &:hover {
    cursor: pointer;
  }
`;

const ListItem = styled.li`
  list-style: none;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: solid 1px #fff;
  border-top: none;
`;

const localeList = ['TW', 'EN']
const navItems = [
  { text: 'ABOUT', href: '#about' },
  { text: 'ROAD MAP', href: '#roadmap' },
  { text: 'TEAM', href: '#team' },
  { text: 'FAQ', href: '#faq' },
  { text: 'FIRM', href: '#firm' },
]
const iconList = [
  { src: igIcon, href: INSTAGRAM_LINK },
  { src: discordIcon, href: DISCORD_LINK },
  { src: twIcon, href: TWITTER_LINK },
]

const AppHeader = () => {
  const { i18n } = useTranslation()

  const [isOpen, setIsOpen] = useState(false);
  const [activeLocale, setActiveLocale] = useState<string>('TW');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onOptionClicked = (value: string) => () => {
    if (value === 'TW') {
      i18n.changeLanguage("zh")
    }
    if (value === 'EN') {
      i18n.changeLanguage("en")
    }
    setActiveLocale(value);
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  }

  return <Header>
    <Logo src={logo} alt='logo' />
    <Nav>
      {
        navItems
          .map(item =>
            <NavItem key={item.text}>
              <NavItemLink href={item.href}>{item.text}</NavItemLink>
            </NavItem>
          )
      }
      <div style={{ display: 'flex', alignItems: 'center', margin: '0 14px' }}>
        <Account />
      </div>
      {
        iconList
          .map(item =>
            <IconItem key={item.src}>
              <a
                href={item.href}
                target="_blank"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', width: '36px', height: '36px', borderRadius: '50%' }}
                rel="noreferrer"
              >
                <img src={item.src} alt='' style={{ width: '22px' }} />
              </a>
            </IconItem>
          )
      }
    </Nav>
    <DropDownContainer style={{ marginLeft: '20px' }}>
      <DropDownHeader onClick={() => setIsOpen(!isOpen)}>
        {activeLocale}
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer>
          <DropDownList>
            {
              localeList
                .filter(locale => locale !== activeLocale)
                .map(locale =>
                  <ListItem onClick={onOptionClicked(locale)} key={`${locale}-option`}>
                    {locale}
                  </ListItem>
                )
            }
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
    <Hamburger onClick={toggleMenu}>
      <div />
      <div />
      <div />
    </Hamburger>
    <Drawer
      visible={isMenuOpen}
      width={120}
      closable={false}
      bodyStyle={{ background: '#000', padding: '26px 6px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      onClose={() => setIsMenuOpen(false)}
      style={{ top: '53px', height: 'calc(100% - 53px)' }}
    >
      <div>

        {
          navItems
            .map(item =>
              <NavItem key={item.text}>
                <NavItemLink href={item.href} onClick={toggleMenu}>{item.text}</NavItemLink>
              </NavItem>
            )
        }
        <div style={{ marginTop: '20px', marginLeft: '8px' }}>
          <div
            style={{
              fontFamily: 'KozGoPr6N-Bold',
              display: 'inline-block',
              padding: '4px 0',
              border: 'solid 1px #fff',
              fontSize: '12px',
              width: '30px',
              textAlign: 'center',
              color: '#fff',
              background: i18n.language === 'zh' ? 'rgba(159, 11, 49)' : '#000'
            }}
            onClick={onOptionClicked('TW')}
          >
            TW
          </div>
          <div style={{
            fontFamily: 'KozGoPr6N-Bold',
            display: 'inline-block',
            padding: '4px 0',
            border: 'solid 1px #fff',
            borderLeft: 'none',
            fontSize: '12px',
            width: '30px',
            textAlign: 'center',
            color: '#fff',
            background: i18n.language === 'zh' ? '#000' : 'rgba(159, 11, 49)'
          }}
            onClick={onOptionClicked('EN')}
          >
            EN
          </div>
        </div>
      </div>
      <div style={{ alignSelf: 'flex-end', paddingRight: '20px' }}>
        {
          iconList
            .map(item =>
              <IconItem key={item.src} onClick={toggleMenu}>
                <a
                  href={item.href}
                  target="_blank"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', width: '36px', height: '36px', borderRadius: '50%' }}
                  rel="noreferrer"
                >
                  <img src={item.src} alt='' style={{ width: '22px' }} />
                </a>
              </IconItem>
            )
        }
      </div>
    </Drawer>
  </Header >
}

export default AppHeader